/**
 * RelationCell Component
 * 
 * Renders Parse Relation values:
 * - Shows "View relation" pill
 * - Click opens relation browser
 * - Displays target class name
 */

import { CellRendererProps, ParseRelation } from '../../../../../types/AppPanel';

export default function RelationCell({ 
  value, 
  field,
  row,
  onRelationClick,
  targetClass 
}: CellRendererProps<ParseRelation | null | undefined>) {
  // Handle null/undefined
  if (value === null || value === undefined) {
    return <span className="text-white/30 italic">(empty)</span>;
  }

  // Get target class from value or prop
  const relClassName = value.className || targetClass || 'Unknown';

  const handleClick = () => {
    onRelationClick?.(relClassName, row.objectId, field);
  };

  return (
    <button
      onClick={handleClick}
      className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full 
                 bg-violet-500/20 text-violet-400 text-xs font-medium
                 hover:bg-violet-500/30 transition-colors cursor-pointer"
      title={`View ${relClassName} relation`}
    >
      <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
              d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
      </svg>
      View relation
    </button>
  );
}

